import { render, staticRenderFns } from "./AddOk.vue?vue&type=template&id=652ee9e0&"
import script from "./AddOk.vue?vue&type=script&lang=js&"
export * from "./AddOk.vue?vue&type=script&lang=js&"
import style0 from "./AddOk.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports